import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { saveCachedVocabulary } from "@/util/vocabularyCache";

// Fetched on every page load (App.jsx): right after login and on each refresh.
// The rows are also cached in localStorage so labels render immediately on a
// refresh while the new copy is fetched.
export const fetchVocabulary = createAsyncThunk("vocabulary/fetchAll", async () => {
  const { data } = await api.get(API_ENDPOINTS.config.vocabulary.getAll);
  const rows = Array.isArray(data) ? data : [];
  saveCachedVocabulary(rows);
  return rows;
});

// Adds a row (id null) or updates one (id set) from the Config Vocabulary
// screen. Values are trimmed so a stray space can't stop a label matching.
// Callers re-dispatch fetchVocabulary() afterwards to apply the change.
export const saveVocabulary = async ({ id = null, english, other }) => {
  const payload = {
    id: id ?? null,
    english: String(english ?? "").trim(),
    other: String(other ?? "").trim(),
  };
  const { data } = await api.post(API_ENDPOINTS.config.vocabulary.saveOrUpdate, payload);
  return data;
};
